import { Icon } from '@chakra-ui/react';

interface Properties {
  width?: number | string;
  height?: number | string;
  color?: string;
}

const DeltaTriangleIcon = ({ width = 2.5, height = 2.5, color = '#FFFFFF' }: Properties) => {
  return (
    <Icon
      viewBox='0 0 10 10'
      width={width}
      height={height}
      color={color}
      display='inline-block'
      verticalAlign='middle'
      aria-hidden='true'
      focusable='false'
    >
      <path d='M5 0 L10 10 H0 Z' fill={color} />
    </Icon>
  );
};

export default DeltaTriangleIcon;
